module.exports = __webpack_public_path__ + "img/ambassador_img1.7cd60278.png";